import React from 'react'
import Main from '../cpn/Main'
import { Card, List,App } from 'antd'
import classes from './desk.module.css';
import PageTitle from '../cpn/PageTitle';
function DeskAbout() {
    const {message} = App.useApp();
    const dd_dq_date= JSON.parse(localStorage.getItem('jtg-caiwu_dd_dq_date')) || '软件使用协议'
    const qy_name= JSON.parse(localStorage.getItem('jtg-caiwu_qy_name')) || '软件使用协议'
    const addToBrowserBookmarks = () => {
        const url = 'https://q1.qidangjia.net';
        const title = '齐当家q1';
        
        // 对于大多数现代浏览器
        if (window.sidebar && window.sidebar.addPanel) { // Firefox
        window.sidebar.addPanel(title, url, '');
        } else if (window.external && ('AddFavorite' in window.external)) { // IE
        window.external.AddFavorite(url, title);
        } else if (window.opera && window.print) { // Opera
        const a = document.createElement('a');
        a.href = url;
        a.title = title;
        a.rel = 'sidebar';
        a.click();
        } else { // 其他浏览器（显示提示）
        alert(`请按Ctrl+D(Windows)或Command+D(Mac)将 "${title}" 添加到收藏夹`);
        }
    };
    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText('https://q1.qidangjia.net');
            message.success('已复制到剪贴板');
        } catch (err) {
            message.error('复制失败');
            console.error('复制失败:', err);
        }
    };
    return (
        <Main  selectedKeys={['/DeskAbout']}>
            <PageTitle title='软件信息' />
            <div className={classes.loginBack} style={{marginTop:"10px"}}>
                <Card 
                    style={{padding:"30px",fontSize:"16px",width:"30%"}}
                >
                    <List>
                        <List.Item>软件名称：齐当家q1</List.Item>
                        <List.Item>企业名称：{qy_name}</List.Item>
                        <List.Item>到期日期：{dd_dq_date}</List.Item>
                        <List.Item><a onClick={addToBrowserBookmarks}>收藏网址</a></List.Item>
                        <List.Item><a onClick={handleCopy}>复制网址</a></List.Item>
                        <List.Item><a onClick={() => {window.open('https://q1.qidangjia.net')}}>购买须知</a></List.Item>
                    </List>
                </Card>
            </div>
        </Main>
    )
}

export default DeskAbout